export default __webpack_public_path__ + "static/media/5 - Meditations.2415dcca.jpeg";